// Drop-in replacement for `toast.success(...)` / `toast.error(...)`.
// Routes all notifications through the centralized notification store
// AND shows a brief inline mini-toast at the bottom-right for immediate
// visual feedback.

import { toast } from 'sonner'
import { useNotificationStore } from './notification-store'

export const notify = {
  success: (msg: string) => {
    useNotificationStore.getState().add('success', msg)
    toast.success(msg, { duration: 3000 })
  },
  error: (msg: string) => {
    useNotificationStore.getState().add('error', msg)
    toast.error(msg, { duration: 4000 })
  },
  info: (msg: string) => {
    useNotificationStore.getState().add('info', msg)
    toast(msg, { duration: 3000 })
  },
  warning: (msg: string) => {
    useNotificationStore.getState().add('warning', msg)
    toast.warning(msg, { duration: 4000 })
  },
}
